import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';
import RepeatIcon from 'src/common/utils/TableColumnIcons/RepeatIcon';

export const ActionColumnFormat = (
	value,
	row,
	rowIndex,
	{ onRepeat, onEye, onDelete, disableBoton }
) => {
	return (
		<div style={{ display: 'flex', gap: '3px', justifyContent: 'center' }}>
			<TrashIcon
				onClick={() => onDelete(value)}
				className={disableBoton ? 'd-none' : 'ml-1'}
				disabled={disableBoton}
			/>
			<EyeIcon onClick={() => onEye(value)} color="light-primary" />
			<RepeatIcon
				onClick={() => onRepeat(row)}
				className={disableBoton ? 'd-none' : 'ml-1'}
				tooltip="Cambiar Estatus"
				disabled={disableBoton}
				color="primary"
			/>
		</div>
	);
};
